import {TSSchadenObjektTyp} from './enums/TSSchadenObjekt';
import {IHasUnconnectedDocuments} from './IHasUnconnectedDocuments';
import TSAbstractEntity from './TSAbstractEntity';
import TSSchadenDaten from './TSSchadenDaten';
import {TSSerializable} from './TSSerializable';

export default class TSSchaden extends TSAbstractEntity implements TSSerializable<TSSchaden>, IHasUnconnectedDocuments {

    private _schadenDatenGS: TSSchadenDaten | undefined;

    private _schadenDatenFS: TSSchadenDaten;

    private _documentIdsToConnect: Array<string> = [];

    private _schadenObjektEnabledMap = {};

    constructor() {
        super();
        this._schadenObjektEnabledMap[TSSchadenObjektTyp.KULTURLAND] = ['versicherung', 'kulturart', 'flaecheAre'];
        this._schadenObjektEnabledMap[TSSchadenObjektTyp.OBSTBAUM_REBSTOECKE] = ['flaecheAre', 'anzahl', 'sorte', 'alter'];
        this._schadenObjektEnabledMap[TSSchadenObjektTyp.STRASSEN_WEGE] = ['laenge', 'breite', 'bauart', 'letzteInstandstellung'];
        this._schadenObjektEnabledMap[TSSchadenObjektTyp.BRUECKEN_DURCHLAESSE] = ['laenge', 'breite', 'alter', 'bauart'];
        this._schadenObjektEnabledMap[TSSchadenObjektTyp.UFER_BACHBAUTEN] = ['laenge', 'alter', 'bauart'];
        this._schadenObjektEnabledMap[TSSchadenObjektTyp.STUETZMAUER_REBMAUERN] = ['laenge', 'breite', 'hoehe', 'alter', 'bauart'];
        this._schadenObjektEnabledMap[TSSchadenObjektTyp.HAUSUMSCHWUNG] = ['versicherung'];
        this._schadenObjektEnabledMap[TSSchadenObjektTyp.EINFRIEDUNG] = ['laenge', 'bauart'];
        this._schadenObjektEnabledMap[TSSchadenObjektTyp.LEITUNGEN_AUSSERHALB_DER_GEBAEUDE] = ['art', 'laenge'];
        this._schadenObjektEnabledMap[TSSchadenObjektTyp.WALD] = ['flaecheAre', 'holzMenge'];
    }

    public get schadenDatenGS(): TSSchadenDaten | undefined {
        return this._schadenDatenGS;
    }

    public set schadenDatenGS(value: TSSchadenDaten | undefined) {
        this._schadenDatenGS = value;
    }

    public get schadenDatenFS(): TSSchadenDaten {
        return this._schadenDatenFS;
    }

    public set schadenDatenFS(value: TSSchadenDaten) {
        this._schadenDatenFS = value;
    }

    public get schadenObjektEnabledMap(): {} {
        return this._schadenObjektEnabledMap;
    }

    /*Nicht benoetigte Felder werden vor dem speichern geloescht*/
    public cleanSchadenObjekt(): void {
        if (this.schadenDatenFS && this.schadenDatenFS.schadenObjektDaten) {
            if (!this.propertyExistsForSchadenObjektType('versicherung')) {
                this.schadenDatenFS.schadenObjektDaten.versicherungVorhanden = undefined;
                this.schadenDatenFS.schadenObjektDaten.versicherungGemeldet = undefined;
            } else {
                if (this.schadenDatenFS.schadenObjektDaten.versicherungVorhanden === false) {
                    this.schadenDatenFS.schadenObjektDaten.versicherungGemeldet = undefined;
                }
            }
            if (!this.propertyExistsForSchadenObjektType('kulturart')) {
                this.schadenDatenFS.schadenObjektDaten.kulturart = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('flaecheAre')) {
                this.schadenDatenFS.schadenObjektDaten.flaecheAre = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('anzahl')) {
                this.schadenDatenFS.schadenObjektDaten.anzahl = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('letzteInstandstellung')) {
                this.schadenDatenFS.schadenObjektDaten.letzteInstandstellung = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('sorte')) {
                this.schadenDatenFS.schadenObjektDaten.sorte = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('alter')) {
                this.schadenDatenFS.schadenObjektDaten.alter = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('laenge')) {
                this.schadenDatenFS.schadenObjektDaten.laenge = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('breite')) {
                this.schadenDatenFS.schadenObjektDaten.breite = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('hoehe')) {
                this.schadenDatenFS.schadenObjektDaten.hoehe = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('bauart')) {
                this.schadenDatenFS.schadenObjektDaten.bauart = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('art')) {
                this.schadenDatenFS.schadenObjektDaten.art = undefined;
            }
            if (!this.propertyExistsForSchadenObjektType('holzMenge')) {
                this.schadenDatenFS.schadenObjektDaten.holzMenge = undefined;
            }
        }
    }

    public propertyExistsForSchadenObjektType(what: string): boolean {
        if (this.schadenDatenFS && this.schadenDatenFS.schadenObjekt) {
            let list = this.schadenObjektEnabledMap[this.schadenDatenFS.schadenObjekt];
            if (list && what) {
                for (let i = 0; i < list.length; i++) {
                    if (list[i] === what) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    deserialize(restObject: any): TSSchaden {
        super.deserialize(restObject);

        this.schadenDatenFS = this.deserializeOrCreate(restObject.schadenDatenFS, new TSSchadenDaten());
        this.schadenDatenGS = this.deserializeOrNull(restObject.schadenDatenGS, new TSSchadenDaten());

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.schadenDatenGS = this.serializeOrInit(this.schadenDatenGS, restObject.schadenDatenGS);
        restObject.schadenDatenFS = this.serializeOrInit(this.schadenDatenFS, restObject.schadenDatenFS);
        restObject.documentIdsToConnect = this.documentIdsToConnect;
        return restObject;
    }

    public static getDeserializer = (schaden: any) => {
        return new TSSchaden().deserialize(schaden);
    };

    public static getSerializer = (schaden: any) => {
        return schaden.serialize(schaden);
    };

    public get documentIdsToConnect(): Array<string> {
        return this._documentIdsToConnect;
    }

    public set documentIdsToConnect(value: Array<string>) {
        this._documentIdsToConnect = value;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSSchaden.ts